<template>
    <v-container fill>
        <v-row no-gutters class="mb-2" style="height: calc(100vh - 160px); overflow-y: auto">
            <v-col>
                <v-btn-back @click.stop="backPath()"></v-btn-back>
            </v-col>

            <v-col cols="12">
                <!-- ** title -->
                <v-row no-gutters class="mt-2 pr-2">
                    <v-col cols="11" class="d-flex align-center col-auto pr-3">
                        Régularisations de fin d'année des lignes avec montants >= 100 &#x20ac; HT
                    </v-col>

                    <v-col
                        v-if="acrStatus && acrStatus === 'UNKNOWN'"
                        cols="1"
                        class="d-flex justify-end align-center"
                    >
                        <v-icon size="small"> $oss-circle-check </v-icon>
                    </v-col>

                    <v-col
                        v-else-if="!acrStatus || acrStatus !== 'TO_UPDATE'"
                        cols="1"
                        class="d-flex justify-end"
                    />
                </v-row>

                <h3 v-if="notCivilPeriodMessage" class="text-primary mt-2 mb-0">
                    {{ notCivilPeriodMessage }}
                </h3>

                <v-row no-gutters class="mb-4">
                    <v-col
                        v-if="acrStatus && acrStatus === 'TO_UPDATE'"
                        class="d-flex justify-start"
                    >
                        <v-icon style="color: red" size="small"> $oss-warning </v-icon>
                    </v-col>

                    <v-col cols="11" style="color: red" v-if="acrUpdatedMessage">
                        {{ acrUpdatedMessage }}
                    </v-col>
                </v-row>

                <v-row v-if="previousClosedApMessage" no-gutters class="mb-2">
                    <v-col class="d-flex align-center col-auto pr-3 text-red">
                        {{ previousClosedApMessage }}
                    </v-col>
                </v-row>

                <v-row no-gutters class="mb-2">
                    <v-col cols="12">
                        <!-- ** amounts -->
                        <template
                            v-if="
                                adjustments &&
                                adjustments.type &&
                                adjustments.lines &&
                                adjustments.lines.length
                            "
                        >
                            <div no-gutters v-for="line in adjustments.lines" :key="line.id">
                                <v-card
                                    class="default_card_wm mx-auto py-2 mb-2"
                                    style="
                                        background: #fff !important;
                                        border: solid rgba(0, 0, 0, 0.12) 1px;
                                        box-shadow: none;
                                    "
                                >
                                    <!-- ** title revision + windowStep = 10 -->
                                    <v-card-text primary-title class="py-0">
                                        <!-- ** original amounts - vatRate -->
                                        <v-row no-gutters class="mb-0 mt-2">
                                            <!-- ** original amount -->
                                            <v-col class="pb-2 pr-2" cols="6">
                                                <oss-text-field-filled
                                                    v-model="line.netAmount"
                                                    persistent-hint
                                                    label="Base HT"
                                                    hide-details
                                                    disabled
                                                />
                                                <!-- append-inner-icon="$euro" -->
                                            </v-col>

                                            <!-- ** adjustment amount -->
                                            <v-col class="pb-2" cols="6">
                                                <oss-text-field-filled
                                                    v-if="line.netAmount"
                                                    v-model="line.adjustment.netAmount"
                                                    :disabled="disabledTextFields"
                                                    :persistentHint="true"
                                                    :label="'HT à régulariser'"
                                                    :hideDetails="true"
                                                    :rules="[
                                                        (v) =>
                                                            v <= line.netAmount ||
                                                            'Valeur maximale ' + [line.netAmount],
                                                        (v) => v >= 0 || 'Valeur minimale ' + [0],
                                                    ]"
                                                    @update:model-value="onAdjustmentsChange()"
                                                />
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters class="mb-0">
                                            <!-- ** vatRate -->
                                            <v-col class="pb-2 pr-2" cols="6">
                                                <oss-text-field-filled
                                                    v-if="
                                                        line.vatRate &&
                                                        typeof line.vatRate === 'number'
                                                    "
                                                    :disabled="disabledTextFields"
                                                    v-model="line.vatRate"
                                                    persistent-hint
                                                    label="TVA %"
                                                    hide-details
                                                />

                                                <!-- ** <OSS-text-field> works only with numbers : if not, use <v-text-field> -->
                                                <v-text-field-filled
                                                    v-else-if="
                                                        line.vatRate &&
                                                        typeof line.vatRate != 'number'
                                                    "
                                                    :disabled="disabledTextFields"
                                                    v-model="line.vatRate"
                                                    persistent-hint
                                                    label="TVA %"
                                                    hide-details
                                                />

                                                <p v-else>Pas de taux de TVA</p>
                                            </v-col>

                                            <!-- ** vatAmount -->
                                            <v-col class="pb-2" cols="6">
                                                <oss-text-field-filled
                                                    v-if="line.vatAmount"
                                                    :disabled="disabledTextFields"
                                                    v-model="line.vatAmount"
                                                    persistent-hint
                                                    label="TVA"
                                                    hide-details
                                                />
                                                <!-- append-inner-icon="$euro" -->

                                                <p v-else>Pas de TVA</p>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters class="mt-0">
                                            <!-- ** 2 datePickers -->
                                            <!-- ** start date -->
                                            <v-col class="pb-2 pr-2" cols="6">
                                                <oss-date-picker-filled
                                                    :hide-details="true"
                                                    label="DU"
                                                    :textFieldReadOnly="false"
                                                    :formatDate="'DD/MM/YYYY'"
                                                    :minDate="minDate"
                                                    v-model="line.adjustment.startDate"
                                                    :disabled="disabledTextFields"
                                                    :error="
                                                        getDatePickerError(
                                                            line.adjustment.startDate,
                                                            line.adjustment.endDate,
                                                        )
                                                    "
                                                    @update:model-value="onAdjustmentsChange()"
                                                />
                                            </v-col>

                                            <!-- ** end date -->
                                            <v-col class="pb-2" cols="6">
                                                <oss-date-picker-filled
                                                    :hide-details="true"
                                                    label="AU"
                                                    :textFieldReadOnly="false"
                                                    :formatDate="'DD/MM/YYYY'"
                                                    :minDate="minDate"
                                                    v-model="line.adjustment.endDate"
                                                    :disabled="disabledTextFields"
                                                    :error="
                                                        getDatePickerError(
                                                            line.adjustment.startDate,
                                                            line.adjustment.endDate,
                                                        )
                                                    "
                                                    @update:model-value="onAdjustmentsChange()"
                                                />
                                            </v-col>
                                        </v-row>

                                        <!-- ++ ADJUSTMENTS -->
                                        <!-- ** AccountableAccount -->
                                        <v-row no-gutters class="mb-0">
                                            <!-- ** totalDaysLength-->
                                            <v-col cols="4" class="d-flex align-center">
                                                <b
                                                    v-if="
                                                        line.adjustment &&
                                                        line.adjustment.totalDaysLength &&
                                                        ((line.adjustment.previousPeriod &&
                                                            line.adjustment.previousPeriod
                                                                .partialAmountSigned) ||
                                                            (line.adjustment.nextPeriod &&
                                                                line.adjustment.nextPeriod
                                                                    .partialAmountSigned))
                                                    "
                                                    >Total
                                                    {{ line.adjustment.totalDaysLength }} jrs</b
                                                >
                                            </v-col>

                                            <v-col cols="2" class="d-flex align-center">
                                                <v-icon
                                                    v-if="line.adjustment.status === 'TO_UPDATE'"
                                                    style="color: red"
                                                    size="small"
                                                >
                                                    $oss-warning
                                                </v-icon>
                                            </v-col>

                                            <!-- ** AccountableAccount -->
                                            <v-col class="pb-2" cols="6">
                                                <!-- ** don't use <oss-text-field> : it works only with numbers -->
                                                <v-text-field-filled
                                                    v-if="
                                                        line.accountableAccount &&
                                                        line.accountableAccount.name
                                                    "
                                                    label="Compte"
                                                    hide-details
                                                    readonly
                                                    disabled
                                                    :model-value="line.accountableAccount.name"
                                                />

                                                <v-text-field-filled
                                                    v-else-if="line.accountableAccount"
                                                    label="Compte"
                                                    hide-details
                                                    readonly
                                                    disabled
                                                    :model-value="
                                                        getDisplayName(line.accountableAccount)
                                                    "
                                                />
                                            </v-col>

                                            <v-spacer />
                                        </v-row>

                                        <div
                                            v-for="(period, index) in line.periods"
                                            :key="index"
                                            class="ma-0 pa-0"
                                        >
                                            <!-- ++ previousPeriod / nextPeriod-->
                                            <!-- ** title cols 12 -->
                                            <v-row no-gutters>
                                                <v-col cols="12">
                                                    <h4
                                                        class="ma-0"
                                                        v-if="line.adjustment[period].textTemplate"
                                                    >
                                                        {{ line.adjustment[period].textTemplate }}
                                                    </h4>

                                                    <h4 class="ma-0" v-else />
                                                </v-col>
                                            </v-row>

                                            <!-- ** adjustments -->
                                            <v-row no-gutters>
                                                <!-- ** dateDiff cols 2 -->
                                                <v-col class="text-left" cols="2">
                                                    <p
                                                        class="ma-0"
                                                        v-if="line.adjustment[period].dateDiff"
                                                    >
                                                        {{ line.adjustment[period].dateDiff }}
                                                        jrs
                                                    </p>
                                                    <p class="ma-0" v-else />
                                                </v-col>

                                                <!-- ** partialAmountSigned cols 4 -->
                                                <v-col class="text-right" cols="4">
                                                    <p
                                                        class="ma-0"
                                                        v-if="
                                                            line.adjustment[period]
                                                                .partialAmountSigned &&
                                                            line.adjustment[period]
                                                                .partialAmountSigned > 0
                                                        "
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                line.adjustment[period]
                                                                    .partialAmountSigned,
                                                                undefined,
                                                            )
                                                        }}
                                                        HT
                                                    </p>
                                                    <p
                                                        class="ma-0"
                                                        v-else-if="
                                                            line.adjustment[period]
                                                                .partialAmountSigned &&
                                                            line.adjustment[period]
                                                                .partialAmountSigned < 0
                                                        "
                                                    >
                                                        {{
                                                            -line.adjustment[period]
                                                                .partialAmountSigned
                                                        }}
                                                        HT
                                                    </p>
                                                    <p class="ma-0" v-else>-</p>
                                                </v-col>

                                                <!-- ** vatRate cols 2 -->
                                                <v-col
                                                    v-if="period === 'previousPeriod'"
                                                    class="text-right"
                                                    cols="2"
                                                >
                                                    <p class="ma-0" v-if="line.vatRate">
                                                        {{ line.vatRate }} %
                                                    </p>
                                                    <p
                                                        class="ma-0"
                                                        v-else-if="line.vatRate === null"
                                                    >
                                                        Libre
                                                    </p>
                                                    <p class="ma-0" v-else>0 %</p>
                                                </v-col>

                                                <v-col v-else class="text-right" cols="2">-</v-col>

                                                <!-- ** vatAmountSigned cols 4 -->
                                                <v-col
                                                    v-if="period === 'previousPeriod'"
                                                    class="text-right"
                                                    cols="4"
                                                >
                                                    <p
                                                        class="ma-0"
                                                        v-if="
                                                            line.adjustment[period].vatAmountSigned
                                                        "
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                Math.abs(
                                                                    line.adjustment[period]
                                                                        .vatAmountSigned,
                                                                ),
                                                                undefined,
                                                            )
                                                        }}
                                                        TVA
                                                    </p>
                                                    <p class="ma-0" v-else>0 TVA</p>
                                                </v-col>

                                                <v-col v-else class="text-right" cols="2">-</v-col>
                                            </v-row>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </div>

                            <v-card
                                v-if="removedLinesMessage && removedLinesMessage.length"
                                class="default_card_wm mx-auto py-2"
                                style="
                                    background: #fff !important;
                                    border: solid rgba(0, 0, 0, 0.12) 1px;
                                    box-shadow: none;
                                "
                            >
                                <!-- ** title revision + windowStep = 10 -->
                                <v-card-text primary-title class="py-0">
                                    <v-row no-gutters>
                                        <v-col cols="2" class="pb-2 pr-2">
                                            <v-icon style="color: red" size="small">
                                                $oss-warning
                                            </v-icon>
                                        </v-col>

                                        <v-col class="pb-2 pr-2">
                                            {{ removedLinesMessage }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>

                        <v-row no-gutters class="my-2" v-if="!disabledValidateBtn">
                            <v-col>
                                <v-spacer />
                            </v-col>
                            <v-col cols="auto" class="d-flex align-center">
                                <v-btn @click="createAdjustments()" size="small"> Générer </v-btn>
                            </v-col>

                            <v-col
                                cols="auto"
                                class="d-flex align-center"
                                v-if="auditCheckResult && auditCheckResult.id"
                            >
                                <!-- ** icon more_vert(ical) with upsert + deleteACR -->
                                <!-- // start -->
                                <v-menu offset-y>
                                    <template v-slot:activator="{ props }">
                                        <v-btn-icon
                                            icon="$dots_vertical"
                                            v-bind="props"
                                            class="mx-1"
                                            color="primary"
                                        />
                                    </template>

                                    <v-list>
                                        <v-list-item
                                            v-if="auditCheckResult && auditCheckResult.id"
                                            @click="deleteAuditCheckResult(auditCheckResult.id)"
                                        >
                                            <v-list-item-title>
                                                Supprimer les régularisations du document
                                            </v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="small"> $oss-trash </v-icon>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row v-if="headerMessage" no-gutters class="mb-2">
                    <v-col class="d-flex align-center col-auto pr-3 text-red">
                        {{ headerMessage }}
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { State2Way } from "@/decorators";
import moment from "moment-timezone";
import { sumBy } from "lodash";
import { User } from "../../store/store";

import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getLastAccountingClosingEndDateFromStore } from "../../services/accountingPeriods";

import { getEmptyDocument } from "../../services/documentServices";
import AccountableAccountVue from "../AccountableAccount.vue";

import QUERY_AUDIT_CHECK_RESULT__FROM_DOCUMENT from "../../graphql/audit/AuditCheckResultsFromDocument.gql";
import UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT from "../../graphql/audit/UpsertAuditCheckResultConnectExistingDocument.gql";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";
import { getDBFormattedDate } from "@/services/dateServices";
import { getConnectAccountableAccount } from "../../services/accountableAccountServices";
import {
    adjustmentsPurchasesConditions,
    adjustmentsSalesConditions,
} from "../../services/documentServices";
import { isInsideAccountingClosing } from "../../services/accountingPeriods";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        AccountableAccountVue,
    },
    emits: ["back"],
})
export class DocumentAdjustments extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: undefined }) thirdPartyCompany: any;
    @Prop({ default: undefined }) document: any;
    @Prop({ default: "" }) documentAcrStatus: string;
    @Prop({ default: undefined }) documentAccountingPeriod: any;
    @Prop({ default: "" }) acKey: string;

    search: string = "";

    @State2Way("updateAccountingPeriods", "accountingPeriod.accountingPeriods")
    accountingPeriods!: any;

    lastClosedAccountingPeriod: any = {};
    previousAccountingPeriod: any = {};

    firstNotClosedDay: any = "";

    aaType: String = "";

    documents: Array<any> = [];

    types: any = {
        purchases: {
            previousPeriod: {
                creditNote: {
                    true: {
                        text: "RRR à obtenir c/4098 TTC",
                        thirdPartyAccountableAccount: "409800",
                    },
                    false: {
                        text: "FNP c/408 TTC",
                        thirdPartyAccountableAccount: "408000",
                    },
                },
                vatAccountableAccount: "445860",
            },
            nextPeriod: {
                creditNote: {
                    true: {
                        text: "Avoir Constaté d'Avance c/486C HT ",
                        thirdPartyAccountableAccount: "486000",
                    },
                    false: {
                        text: "CCA c/486 HT",
                        thirdPartyAccountableAccount: "486000",
                    },
                },
            },
        },
        sales: {
            previousPeriod: {
                creditNote: {
                    true: {
                        text: "AAE c/4198 TTC",
                        thirdPartyAccountableAccount: "419800",
                    },
                    false: {
                        text: "FAE c/418 TTC",
                        thirdPartyAccountableAccount: "418000",
                    },
                },
                vatAccountableAccount: "445870",
            },
            nextPeriod: {
                creditNote: {
                    true: {
                        text: "Avoir Constaté d'Avance c/487D HT ",
                        thirdPartyAccountableAccount: "487000",
                    },
                    false: {
                        text: "PCA c/487 HT",
                        thirdPartyAccountableAccount: "487000",
                    },
                },
            },
        },
    };

    defaultAdjustments: any = {
        type: "",
        lines: [],
        closed: false,
        previousAccountingPeriod: {},
        previousDate: undefined,
        nextDate: undefined,
    };

    adjustments: any = {};

    lineAdjustmentPeriodDefault: any = {
        originalDocument: {},
        dateDiff: 0,
        partialAmountSigned: 0,
        vatAmountSigned: 0,
        accountingLines: [],
        thirdPartyAccountableAccount: "",
        thirdPartyCompany: {},
        vatAccountableAccount: "",
        textTemplate: "",
        wording: "",
        wordingCommon: "",
        status: "",
    };

    adjustmentAccountingLinesDefault: any = {
        previousPeriod: [],
        nextPeriod: [],
    };

    adjustmentDocument: any = {};

    // acKeyPurchases: string = "FLoYFf9NewVjg7fJyAb6Iucj"
    // acKeySales: string = "eZZcPLQGRZHBLwNM34gpkRpg"

    auditCheckKey: String = "";

    acrStatus: String = "";

    adjustmentDialog: boolean = false;

    headerMessage: String = "";

    notCivilPeriodMessage: String = "";

    previousClosedApMessage: String = ""; // only FNP

    removedLinesMessage: String = "";

    completeDates: boolean = false;

    orderedDates: boolean = false;

    differentAdjustments_acrData: boolean = false;

    controlThirdPartyCompany: any = {};

    // ** document, coming from props
    // ** if document is in accountingClosing or accountingPeriod.closed
    // ** set in mounted
    isClosed: boolean = false;

    // ** ACR, if exists, comes from Apollo query
    // ** some dates may be in closed periods
    lockedACR: boolean = false;

    // ** if no accountingPeriods or isClosed or lockedACR
    // ** textfields need to be actives if orderedDates or completeDates issues permitting to fix them
    disabledTextFields: boolean = false;

    // ** if isClosed or lockedACR
    // ** or no accountingPeriods
    // ** or if not isClosed and not lockedACR but with orderedDates or completeDates issues
    disabledValidateBtn: boolean = false;

    tpcIdUpsertObject: any = undefined;
    tpcIdNameObject: any = undefined;

    documentDateYYYYMMDD: string = undefined;
    periodStart: string = undefined;
    periodEnd: string = undefined;
    periodStartYYYYMMDD00: string = undefined;
    periodEndYYYYMMDD00: string = undefined;

    // ** usefull only if textfields and datePickers are availables
    minDate: string = undefined; // ** for date-picker
    minDateYYYYMMDD00: string = undefined; // ** for calculations

    beforeMount() {
        this.initialize();

        this.acrStatus = this.documentAcrStatus || "";

        if (
            this.documentAccountingPeriod?.start && 
            this.documentAccountingPeriod?.end
        ) {
            if (
                moment(this.documentAccountingPeriod.start).format("MM-DD") != "01-01" || 
                moment(this.documentAccountingPeriod.end).format("MM-DD") != "12-31"
            ) {   
                this.notCivilPeriodMessage = "L'exercice comptable est du " + this.formatDate(this.documentAccountingPeriod.start) + " au " + this.formatDate(this.documentAccountingPeriod.end) + " et ne correspond pas avec l'année civile : ne soyez pas surpris par le nombre de jours des régularisations.";
            }
        }

        // ** firstNotClosedDay
        if (this.accountingPeriods?.length) {
            const lastAccountingClosingDate = getLastAccountingClosingEndDateFromStore(this.$store);
            this.firstNotClosedDay = lastAccountingClosingDate
                ? moment(lastAccountingClosingDate).add(1, "days").format("YYYY-MM-DD")
                : this.accountingPeriods[0]?.start 
                ? moment(this.accountingPeriods[0].start).format("YYYY-MM-DD") 
                : undefined;

            this.minDate = getDBFormattedDate(this.firstNotClosedDay); // ** for date-picker
            this.minDateYYYYMMDD00 = this.firstNotClosedDay; // ** for calculations

            if (
                this.document?.accountingClosing?.startDate &&
                this.document?.accountingClosing?.endDate
            ) {
                this.periodStart = getDBFormattedDate(this.document.accountingClosing.startDate);
                this.periodEnd = getDBFormattedDate(this.document.accountingClosing.endDate);
            } else if (this.documentAccountingPeriod?.start && this.documentAccountingPeriod?.end) {
                this.periodStart = getDBFormattedDate(this.documentAccountingPeriod.start);
                this.periodEnd = getDBFormattedDate(this.documentAccountingPeriod.end);
            }

            if (this.periodStart && this.periodEnd) {
                this.periodStartYYYYMMDD00 = moment(this.periodStart).format("YYYY-MM-DD");
                this.periodEndYYYYMMDD00 = moment(this.periodEnd).format("YYYY-MM-DD");
            }
        } else {
            this.headerMessage = "Vous n'avez pas créé d'exercice comptable";
            this.firstNotClosedDay = "";
            this.disabledTextFields = true;
            this.disabledValidateBtn;
        }

        // ** acKey for purchases or sales
        this.defaultAdjustments.type =
            this.acKey && this.acKey === "FLoYFf9NewVjg7fJyAb6Iucj" ? "purchases" : "sales";

        this.adjustments.type =
            this.acKey && this.acKey === "FLoYFf9NewVjg7fJyAb6Iucj"
                ? "purchases"
                : this.acKey === "eZZcPLQGRZHBLwNM34gpkRpg"
                  ? "sales"
                  : "";

        if (this.adjustments.type === "") {
            console.error("no document.type in DocumentAdjustments");
            debugger;
        }

        const previousPeriodEnd = moment(this.periodStart)
            .clone()
            .add(-1, "days")
            .format("YYYY-MM-DD");

        this.adjustments.previousAccountingPeriod = this.accountingPeriods.find((ap) =>
            ap.end.startsWith(previousPeriodEnd),
        );

        // ** thirdPartyCompany
        if (!this.thirdPartyCompany?.id) {
            if (this.document?.accountingLines?.length) {
                const alTPC = this.document.accountingLines.find(
                    (al) => al.thirdPartyCompany && al.thirdPartyCompany.id,
                );
                if (alTPC) {
                    this.controlThirdPartyCompany = alTPC.thirdPartyCompany || {};
                }
            }
        } else {
            this.controlThirdPartyCompany = this.thirdPartyCompany;
        }

        this.tpcIdUpsertObject = this.thirdPartyCompany?.id
            ? { connect: { id: this.thirdPartyCompany.id } }
            : this.controlThirdPartyCompany?.id
              ? { connect: { id: this.controlThirdPartyCompany.id } }
              : undefined;

        this.tpcIdNameObject = this.thirdPartyCompany?.id
            ? { id: this.thirdPartyCompany.id, name: this.thirdPartyCompany.name }
            : this.controlThirdPartyCompany.id
              ? { id: this.controlThirdPartyCompany.id, name: this.controlThirdPartyCompany.name }
              : undefined;

        // ** previous period is closed
        if (this.adjustments?.previousAccountingPeriod?.closed) {
            if (this.adjustments.lines && this.adjustments.lines.length) {
                const foundedPreviousPeriod = this.adjustments.lines.filter(
                    (l) =>
                        l.adjustment.previousPeriod &&
                        Object.keys(l.adjustment.previousPeriod).length,
                );
                if (foundedPreviousPeriod.length) {
                    this.previousClosedApMessage =
                        "N-1 clôturé : impossible de modifier les FNP ou FAE passées";
                } else {
                    this.previousClosedApMessage = "N-1 clôturé : impossible de créer des FNP";
                }
            }
        }

        if (this.document) {
            this.documentDateYYYYMMDD = moment(this.document.date).format("YYYY-MM-DD");
            this.isClosed =
                this.document?.accountingClosing || this.documentAccountingPeriod?.closed;

            if (this.isClosed) {
                this.headerMessage =
                    "Document clôturé : impossible de saisir ou de modifier les régularisations";
                this.disabledTextFields = true;
                this.disabledValidateBtn = true;
            }

            if (!this.isClosed) {
                let al6or7: Array<any> = [];
                if (this.document.accountingLines?.length) {
                    // ++ OD
                    al6or7 = this.document.accountingLines.filter(
                        (al) =>
                            adjustmentsPurchasesConditions(al) || adjustmentsSalesConditions(al),
                    );
                }

                if (al6or7) {
                    const globalNetAmountSigned = sumBy(al6or7, (al) => al.amountSigned);

                    this.adjustments.lines = al6or7.filter(
                        (al) => al.amountSigned >= 100 || al.amountSigned <= -100,
                    );

                    if (this.adjustments.lines.length) {
                        for (const al of this.adjustments.lines) {
                            al.netAmountSigned = mathFix(al.amountSigned, 2);
                        }

                        const al445 = this.document.accountingLines.filter((al) =>
                            al.accountableAccount?.name?.startsWith("445"),
                        );

                        if (al445?.length) {
                            const al445amountSigned = sumBy(al445, function (al: any) {
                                return al.amountSigned;
                            });

                            if (al445amountSigned && globalNetAmountSigned) {
                                for (const al of this.adjustments.lines) {
                                    al.vatAmountSigned = mathFix(
                                        (al.amountSigned * al445amountSigned) /
                                            globalNetAmountSigned,
                                        2,
                                    );
                                    al.vatRate = "Libre";
                                }
                            }
                        }
                    }
                }

                if (!this.adjustments?.lines?.length) {
                    this.headerMessage = "Aucune ligne avec montant >= 100€";
                } else {
                    this.adjustments.lines = this.adjustments.lines.map((x) => ({
                        ...x,
                        sign: x.amountSigned >= 100 ? "+" : "-",
                        periods: [],
                        netAmount: Math.abs(x.amountSigned),
                        vatAmount: Math.abs(x.vatAmountSigned) || 0,
                        date: getDBFormattedDate(this.document.date),
                        thirdPartyCompany: this.tpcIdNameObject || undefined,
                        adjustment: {
                            startDate: getDBFormattedDate(this.document.date),
                            endDate: getDBFormattedDate(this.document.date),
                            totalDaysLength: 0,
                            previousPeriod: {},
                            nextPeriod: {},
                            creditNote: false,
                            sign: x.amountSigned >= 100 ? "+" : "-",
                            netAmountSigned: x.amountSigned || 0,
                            netAmount: Math.abs(x.amountSigned) || 0,
                            vatAmountSigned: x.vatAmountSigned || 0,
                            vatAmount: Math.abs(x.vatAmountSigned) || 0,
                            status: "",
                        },
                    }));

                    const startDates = this.adjustments.lines.map(
                        (adl) => adl.adjustment?.startDate,
                    );
                    if (startDates?.some((sd) => isInsideAccountingClosing(this.$store, sd))) {
                        this.headerMessage =
                            "Des régulatisations ont été validées sur un exercice comptable clôturé";
                        this.lockedACR = true;
                        // this.disabledTextFields = true;
                        this.disabledValidateBtn = true;
                        this.headerMessage =
                            "Des régulatisations ont été validées sur un exercice comptable clôturé";
                        this.lockedACR = true;
                    }
                }
            }
        }
    }

    async onAdjustmentsChange() {
        const documentDateYYYYMMDD = moment(this.document.date).format("YYYY-MM-DD") || "";
        if (this.adjustments.lines?.length) {
            for (const line of this.adjustments.lines) {
                // ** line is a 6 or 7 accountingLine, >= 100 €
                if (!line.netAmount && line.netAmountSigned) {
                    line.netAmount = Math.abs(line.netAmountSigned);
                }

                if (
                    !line.adjustment?.netAmount &&
                    (line.adjustment?.netAmountSigned || line.netAmountSigned)
                ) {
                    line.adjustment.netAmount = Math.abs(
                        line.adjustment?.netAmountSigned || line.netAmountSigned,
                    );
                }

                if (!line.vatAmount && line.vatAmountSigned) {
                    line.vatAmount = Math.abs(line.vatAmountSigned);
                }

                line.adjustment.startDate = moment(line.adjustment.startDate).format("YYYY-MM-DD");
                line.adjustment.endDate = moment(line.adjustment.endDate).format("YYYY-MM-DD");
            }
        }

        if (!this.lockedACR) {
            // ** if some different adjustment start or end dates from document.date
            const someAdjustmentsDifferentDates = this.adjustments.lines?.some(
                (al) =>
                al.adjustment?.startDate !== documentDateYYYYMMDD ||
                al.adjustment?.endDate !== documentDateYYYYMMDD,
            );
            if (someAdjustmentsDifferentDates) {
                const startDates = this.adjustments.lines.map((adl) => adl.adjustment?.startDate);
                if (
                    this.auditCheckResult?.results?.length &&
                    this.firstNotClosedDay &&
                    this.firstNotClosedDay.length
                ) {
                    for (const doc of this.auditCheckResult.results) {
                        const acrDocOnClosedPeriod =
                            doc.date < getDBFormattedDate(this.firstNotClosedDay);

                        if (acrDocOnClosedPeriod) {
                            this.headerMessage =
                                "Régul déjà comptabilisée sur exercice comptable clôturé";
                            this.lockedACR = true;
                            this.disabledTextFields = true;
                            this.disabledValidateBtn = true;
                        }
                    }
                }

                if (!this.lockedACR) {
                    // this.onAuditCheckResultChanged();
                    for (const line of this.adjustments.lines) {
                        if (!this.completeDates) {
                            this.completeDates =
                                moment(line.adjustment?.startDate).isValid() &&
                                moment(line.adjustment?.endDate).isValid();
                        }
                    }
                    if (!this.completeDates) {
                        this.headerMessage = "Dates incomplètes";
                        this.disabledValidateBtn = true;
                    } else {
                        const startDates = this.adjustments.lines.map(
                            (adl) => adl.adjustment?.startDate,
                        );
                        const endDates = this.adjustments.lines.map(
                            (adl) => adl.adjustment?.endDate,
                        );
                        const someDateInAccountingClosing =
                            startDates?.some((sd) => isInsideAccountingClosing(this.$store, sd)) ||
                            endDates?.some((sd) => isInsideAccountingClosing(this.$store, sd));
                        if (someDateInAccountingClosing) {
                            this.headerMessage =
                                "Des dates sont comprises dans un exercice comptable clôturé";
                            // this.disabledTextFields = true;
                            this.disabledValidateBtn = true;
                        } else {
                            for (const line2 of this.adjustments.lines) {
                                await this.calculateAdjustments(line2);
                            }
                            this.headerMessage = "";
                            this.disabledValidateBtn = false;
                        }
                    }
                }
            }
        }

        if (
            !this.lockedACR &&
            !this.disabledTextFields &&
            !this.disabledValidateBtn &&
            this.completeDates
        ) {
            this.headerMessage = "";
        }
    }

    @Apollo({
        query: QUERY_AUDIT_CHECK_RESULT__FROM_DOCUMENT,
        variables() {
            const key = this.acKey + "_" + this.document.id;
            return {
                key: key,
            };
        },
        skip() {
            return !this.acKey || !this.document || !this.document.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.lockedACR = false;
                    if (this.document) {
                        if (data.auditCheckResult) {
                            this.auditCheckResult = data?.auditCheckResult || null;

                            this.previousDocumentsIds =
                                this.auditCheckResult.results?.map((rd) => rd.id) || [];

                            if (this.auditCheckResult?.data?.length) {
                                this.adjustments.lines = this.auditCheckResult.data;
                            }
                        }
                    }
                } else {
                    this.acrStatus = "";
                }
            }
        },
    })
    auditCheckResult: any = {};

    previousDocumentsIds: Array<any> = [];

    async onAuditCheckResultChanged() {
        // if (this.auditCheckResult.id && this.auditCheckResult?.results?.length) {
        if (this.auditCheckResult.id) {
            this.auditCheckKey = this.auditCheckResult.key || "";

            // this.adjustments.lines = this.auditCheckResult?.data

            // const acrResultDocuments = this.auditCheckResult.results

            const acrData = this.auditCheckResult.data;

            if (acrData.originalDocumentChange?.date) {
                this.acrUpdatedMessage +=
                    "Document original modifié le " +
                    acrData.originalDocumentChange.date +
                    ". Supprimez les régularisations pour les recalculer";
            }

            if (this.adjustments.lines?.length) {
                // for (const line of this.adjustments.lines) {
                //     line.netAmount = Math.abs(line.netAmountSigned) || 0;
                //     if (line.vatAmountSigned) {
                //         line.vatAmount = Math.abs(line.vatAmountSigned) || 0;
                //     }
                // }

                if (acrData.length) {
                    if (this.lockedACR) {
                        for (let i = 0; i < acrData.length; i++) {
                            this.adjustments.lines[i].adjustment = acrData[i].adjustment;

                            this.adjustments.lines[i].adjustment.status = "UNKNOWN";
                            if (
                                !this.adjustments.lines[i].periods?.length &&
                                this.adjustments.lines[i].adjustment
                            ) {
                                if (
                                    this.adjustments.lines[i].adjustment.previousPeriod
                                        ?.partialAmountSigned
                                ) {
                                    this.adjustments.lines[i].periods.push("previousPeriod");
                                }
                                if (
                                    this.adjustments.lines[i].adjustment.nextPeriod
                                        ?.partialAmountSigned
                                ) {
                                    this.adjustments.lines[i].periods.push("nextPeriod");
                                }
                            }

                            // await this.calculateAdjustments(this.adjustments.lines[i])
                        }
                    } else if (acrData.length != this.adjustments.lines.length) {
                        this.removedLinesMessage =
                            "Un ou plusiers comptes ont été supprimés : valider pour les effacer";
                    } else {
                        for (let i = 0; i < acrData.length; i++) {
                            const sameDate =
                                moment(acrData[i].date).format("YYYY-MM-DD") ===
                                moment(this.adjustments.lines[i].date).format("YYYY-MM-DD");

                            const acrAA =
                                acrData[i].accountableAccount?.name ||
                                acrData[i].accountableAccount;

                            const adjLineAA =
                                this.adjustments.lines[i].accountableAccount?.name ||
                                this.adjustments.lines[i].accountableAccount;

                            if (
                                acrAA &&
                                adjLineAA &&
                                acrAA === adjLineAA &&
                                sameDate &&
                                acrData[i].netAmountSigned ===
                                    this.adjustments.lines[i].netAmountSigned &&
                                (!acrData[i].vatAmountSigned ||
                                    acrData[i].vatAmountSigned ===
                                        this.adjustments.lines[i].vatAmountSigned) &&
                                (!acrData[i].thirdPartyCompany?.id ||
                                    acrData[i].thirdPartyCompany.id ===
                                        this.controlThirdPartyCompany.id)
                            ) {
                                this.adjustments.lines[i].adjustment = acrData[i].adjustment;

                                this.adjustments.lines[i].adjustment.status = "UNKNOWN";

                                await this.calculateAdjustments(this.adjustments.lines[i]);
                            } else {
                                if (this.previousDocumentsIds.length) {
                                    if (this.acrStatus && this.acrStatus !== "TO_UPDATE") {
                                        this.acrStatus = "TO_UPDATE";
                                    }
                                    this.adjustments.lines[i].adjustment.status = "TO_UPDATE";
                                    await this.calculateAdjustments(this.adjustments.lines[i]);
                                }
                            }
                        }
                    }
                }

                if (this.acrStatus === "TO_UPDATE") {
                    // //// TODO
                    // //// supprimer les results automatiquement ?
                    // //// update this.document.auditCheckResults  find
                    // this.createAdjustments()
                }
            }
        }
    }

    acrUpdatedMessage: string = "";

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    newCommonFormatCurrency(value, options: any = undefined) {
        return newCommonFormatCurrency(value, options);
    }

    backPath() {
        this.$emit("back");
    }

    async calculateAdjustments(line) {
        if (this.disabledTextFields) {
            return;
        }
        const indexLine = this.adjustments.lines.findIndex((l) => l.id === line.id);

        // ** ALIASES
        const startYYYYMMDD = moment(line.adjustment.startDate).format("YYYY-MM-DD") || "";
        const endYYYYMMDD = moment(line.adjustment.endDate).format("YYYY-MM-DD") || "";
        const documentDateYYYYMMDD = this.documentDateYYYYMMDD
        const document = this.document;
        const minDateYYYYMMDD00 = this.minDateYYYYMMDD00 || undefined;
        const periodStartYYYYMMDD00 = this.periodStartYYYYMMDD00 || undefined;
        const periodEndYYYYMMDD00 = this.periodEndYYYYMMDD00 || undefined;

        if (
            line.periods?.length || (
                documentDateYYYYMMDD !== startYYYYMMDD ||
                documentDateYYYYMMDD !== endYYYYMMDD
            ) 
        ) {
            this.orderedDates = startYYYYMMDD <= endYYYYMMDD;

            if (this.completeDates && this.orderedDates) {
                const tpcName = this.tpcIdNameObject?.name || "";
                let otherAccountableAccount = line.accountableAccount?.name
                    ? line.accountableAccount.name
                    : "";
                otherAccountableAccount += line.accountableAccount?.description
                    ? " " + line.accountableAccount.description
                    : "";
                // ** wordingCommon
                let wordingCommon = "";
                wordingCommon += tpcName || otherAccountableAccount || "";

                wordingCommon += document.invoiceNumber
                    ? " s/" + document.invoiceNumber
                    : " s/facture";
                wordingCommon += " du " + this.formatDate(document.date) + " -";
                wordingCommon += " base HT " + newCommonFormatCurrency(line.netAmount) + " -";
                wordingCommon +=
                    " du " +
                    this.formatDate(line.adjustment.startDate) +
                    " au " +
                    this.formatDate(line.adjustment.endDate);
                line.wordingCommon = wordingCommon;

                const dateDiff = moment(line.adjustment.endDate).diff(
                    moment(line.adjustment.startDate),
                    "days",
                );
                if (dateDiff >= 0) {
                    line.adjustment.totalDaysLength = dateDiff;
                } else {
                    line.adjustment.totalDaysLength = 1;
                }

                if (!line.periods) {
                    line.periods = [];
                }
                // ++ PREVIOUS +++++++
                if (
                    startYYYYMMDD < periodStartYYYYMMDD00 &&
                    (!minDateYYYYMMDD00 || minDateYYYYMMDD00 <= startYYYYMMDD)
                ) {
                    // ** FNP - Factures Non Parvenues - 6 + 44586 à 408 31-12-N-1
                    // ** OR
                    // ** FAE - Factures à établir - 418 à 7 + 44587

                    // ** if no previousPeriod
                    if (!line.periods?.length || !line.periods.includes("previousPeriod")) {
                        line.periods.push("previousPeriod");
                    }
                    // ** if empty previousPeriod
                    if (!line.adjustment.previousPeriod?.textTemplate?.length) {
                        line.adjustment.previousPeriod = JSON.parse(
                            JSON.stringify(this.lineAdjustmentPeriodDefault),
                        );
                    }
                } else {
                    // ** erase existing previousPeriod
                    const findIndex = line.periods.findIndex(
                        (p) => p === "previousPeriod",
                    );
                    if (findIndex >= 0) {
                        line.periods.splice(findIndex, 1);
                    }
                    if (this.auditCheckResult?.data) {
                        if (
                            this.auditCheckResult.data[indexLine].adjustment.previousPeriod?.dateDiff
                        ) {
                            this.differentAdjustments_acrData = true;
                            delete line.adjustment.previousPeriod;
                        }
                    }
                }

                // ++ NEXT
                if (
                    periodEndYYYYMMDD00 &&
                    periodEndYYYYMMDD00 < endYYYYMMDD &&
                    (!minDateYYYYMMDD00 || minDateYYYYMMDD00 <= endYYYYMMDD)
                ) {
                    // ** CCA - Charges Constatées d'Avance - 486 à 6 (HT)
                    // ** OR
                    // ** PCA - Produits Constatés d'avance - 7 à 487 (HT)

                    // ** if no nextPeriod
                    if (!line.periods?.length || !line.periods.includes("nextPeriod")) {
                        line.periods.push("nextPeriod");
                    }

                    // ** if empty nextPeriod
                    if (!line.adjustment.nextPeriod?.textTemplate) {
                        line.adjustment.nextPeriod = JSON.parse(
                            JSON.stringify(this.lineAdjustmentPeriodDefault),
                        );
                    }
                } else {
                    const findIndex = line.periods.findIndex((p) => p === "nextPeriod");
                    if (findIndex >= 0) {
                        line.periods.splice(findIndex, 1);
                    }
                    // ** erase existing nextPeriod
                    if (this.auditCheckResult && this.auditCheckResult.data) {
                        if (this.auditCheckResult.data[indexLine].adjustment.nextPeriod?.dateDiff) {
                            this.differentAdjustments_acrData = true;
                            delete line.adjustment.nextPeriod
                        }
                    }
                }

                if (line.periods.length) {
                    for (const period of line.periods) {
                        const periodTypes = JSON.parse(
                            JSON.stringify(this.types[this.adjustments.type][period]),
                        );
                        // ** set values from periodTypes
                        let creditNote = "false";

                        if (line.accountableAccount?.name?.startsWith("7")) {
                            creditNote = (line.amountSigned > 0).toString();
                        } else if (line.accountableAccount?.name?.startsWith("6")) {
                            creditNote = (line.amountSigned < 0).toString();
                        }

                        line.adjustment[period].textTemplate =
                            periodTypes.creditNote[creditNote].text;

                        line.adjustment[period].wording =
                            periodTypes.creditNote[creditNote].text + " - ";

                        line.adjustment[period].wording +=
                            moment(this.documentAccountingPeriod.start).format("YYYY") + " - ";

                        line.adjustment[period].thirdPartyAccountableAccount =
                            periodTypes.creditNote[creditNote].thirdPartyAccountableAccount;
                        line.adjustment[period].text =
                            periodTypes.creditNote[creditNote].text + " - ";

                        // ** dateDiff
                        if (endYYYYMMDD < periodStartYYYYMMDD00) {
                            // ** all in previousPeriod period
                            line.adjustment.previousPeriod.dateDiff = moment(endYYYYMMDD).diff(
                                moment(startYYYYMMDD),
                                "days",
                            );
                        } else if (periodEndYYYYMMDD00 < startYYYYMMDD) {
                            // **
                            line.adjustment.nextPeriod.dateDiff = moment(endYYYYMMDD).diff(
                                moment(startYYYYMMDD),
                                "days",
                            );
                        } else {
                            // ** startDate in previous and endDate in next
                            if (startYYYYMMDD < periodStartYYYYMMDD00) {
                                line.adjustment.previousPeriod.dateDiff = moment(
                                    periodStartYYYYMMDD00,
                                ).diff(moment(startYYYYMMDD), "days");
                            }
                            if (periodEndYYYYMMDD00 < endYYYYMMDD) {
                                line.adjustment.nextPeriod.dateDiff = moment(endYYYYMMDD).diff(
                                    moment(periodEndYYYYMMDD00),
                                    "days",
                                ); // ** OK
                            }
                        }

                        // ** partialAmount
                        const sign = Math.sign(line.netAmountSigned);
                        line.adjustment.netAmountSigned =
                            Math.sign(line.adjustment.netAmount) === sign
                                ? line.adjustment.netAmount
                                : line.adjustment.netAmount * -1;

                        if (
                            line.adjustment.netAmountSigned &&
                            line.adjustment[period].dateDiff &&
                            line.adjustment.totalDaysLength
                        ) {
                            line.adjustment[period].partialAmountSigned = mathFix(
                                (line.adjustment.netAmountSigned *
                                    line.adjustment[period].dateDiff) /
                                    line.adjustment.totalDaysLength,
                                2,
                            );
                        }
                        // ** vatAmountSigned
                        if (
                            line.vatAmountSigned &&
                            line.adjustment[period].dateDiff &&
                            line.adjustment.totalDaysLength
                        ) {
                            if (!line.vatAmountSigned || period !== "previousPeriod") {
                                line.adjustment[period].vatAmountSigned = 0;
                            } else {
                                line.adjustment[period].vatAmountSigned = mathFix(
                                    (line.adjustment[period].partialAmountSigned *
                                        line.vatAmountSigned) /
                                        line.netAmountSigned,
                                    2,
                                );
                                line.adjustment[period].vatAccountableAccount =
                                    periodTypes.vatAccountableAccount;
                            }
                        }

                        // ++ accountingLines
                        const previousPeriodEnd = moment(this.periodStart)
                            .clone()
                            .add(-1, "days")
                            .format("YYYY-MM-DD");

                        this.adjustments.previousAccountingPeriod = this.accountingPeriods.find(
                            (ap) => ap.end.startsWith(previousPeriodEnd),
                        );

                        if (period === "previousPeriod") {
                            if (
                                this.adjustments.previousAccountingPeriod &&
                                !this.adjustments.previousAccountingPeriod.closed
                            ) {
                                this.adjustments.previousDate = getDBFormattedDate(
                                    this.adjustments.previousAccountingPeriod.end,
                                );
                            }
                        } else {
                            this.adjustments.nextDate = getDBFormattedDate(this.periodEnd);
                        }

                        // ** sign:
                        // ** if previousPeriod > increase N-1 with same sign
                        // ** if nextPeriod > decrease N with opposite sign
                        const aaName =
                            periodTypes[this.adjustments.type] === "sales"
                                ? line.accountableAccount + "050"
                                : line.accountableAccount && line.accountableAccount.name
                                  ? line.accountableAccount.name
                                  : line.accountableAccount;
                        line.adjustment[period].accountingLines = [
                            {
                                company: { connect: { id: this.companyId } },
                                // type: "MANAGACCOU", // ** default value
                                date:
                                    period === "previousPeriod"
                                        ? getDBFormattedDate(this.adjustments.previousDate)
                                        : getDBFormattedDate(this.adjustments.nextDate),
                                wording: line.adjustment[period].wording + line.wordingCommon,
                                amountSigned:
                                    period === "previousPeriod"
                                        ? line.adjustment[period].partialAmountSigned
                                        : -line.adjustment[period].partialAmountSigned,
                                amount: Math.abs(line.adjustment[period].partialAmountSigned),
                                accountableAccount: await getConnectAccountableAccount(
                                    this.$store,
                                    this.$apollo,
                                    aaName,
                                ),
                            },
                        ];

                        if (period === "previousPeriod" && line.vatAmountSigned) {
                            // ** VAT
                            line.adjustment[period].accountingLines.push({
                                company: { connect: { id: this.companyId } },
                                // type: "MANAGACCOU", // ** default value
                                date: getDBFormattedDate(this.adjustments.previousDate),
                                wording: line.adjustment[period].wording + line.wordingCommon,
                                amountSigned: line.adjustment.previousPeriod.vatAmountSigned || 0,
                                amount:
                                    Math.abs(line.adjustment.previousPeriod.vatAmountSigned) || 0,
                                // thirdPartyAccountableAccount: "445860"
                                accountableAccount: await getConnectAccountableAccount(
                                    this.$store,
                                    this.$apollo,
                                    line.adjustment.previousPeriod.vatAccountableAccount,
                                ),
                            });
                        }

                        // ++ line.adjustment.status
                        const diffDates = moment(line.adjustment.endDate)
                            .endOf("day")
                            .diff(moment(line.adjustment.startDate).endOf("day"), "days");

                        if (!diffDates) {
                            // ** not modified if already TO_UPDATE
                            if (line.adjustment.status != "TO_UPDATE") {
                                line.adjustment.status = "";
                            } else {
                                line.adjustment.status = "TO_UPDATE";
                            }
                        } else if (
                            (startYYYYMMDD &&
                                endYYYYMMDD &&
                                !minDateYYYYMMDD00 &&
                                startYYYYMMDD < endYYYYMMDD &&
                                line.adjustment &&
                                line.netAmountSigned &&
                                line.adjustment.netAmountSigned &&
                                line.netAmountSigned >= line.adjustment.netAmountSigned) ||
                            (startYYYYMMDD >= minDateYYYYMMDD00 && endYYYYMMDD >= minDateYYYYMMDD00)
                        ) {
                            line.adjustment.status = "UNKNOWN";
                        } else {
                            line.adjustment.status = "";
                        }
                    }

                    this.adjustments.lines[indexLine].periods = line.periods;

                    this.adjustments.lines[indexLine].adjustment = line.adjustment;

                    const toUpdateStatus = this.adjustments.lines.filter(
                        (line) => line.adjustment.status === "TO_UPDATE",
                    );

                    this.acrStatus = toUpdateStatus.length ? "TO_UPDATE" : "UNKNOWN";
                }
            }
        }
    }

    async createAdjustments() {
        this.documents = [];

        // **** push 6 or 7 + 445 accountingLines
        // **** to adjustmentAccountingLines.previousPeriod or nextPeriod
        for (const line of this.adjustments.lines) {
            let adjustmentAccountingLines = JSON.parse(
                JSON.stringify(this.adjustmentAccountingLinesDefault),
            );
            if (line.adjustment?.previousPeriod?.accountingLines?.length) {
                adjustmentAccountingLines.previousPeriod.push(
                    ...line.adjustment.previousPeriod.accountingLines,
                );
            }
            if (line.adjustment?.nextPeriod?.accountingLines?.length) {
                adjustmentAccountingLines.nextPeriod.push(
                    ...line.adjustment.nextPeriod.accountingLines,
                );
            }

            // **** generate 445 and 408 or 486 sums accountingLines
            // **** generate adjDocument and push to this.documents
            if (line.periods?.length) {
                for (const period of line.periods) {
                    if (
                        adjustmentAccountingLines &&
                        adjustmentAccountingLines[period] &&
                        adjustmentAccountingLines[period].length
                    ) {
                        // ** sumVatAmountsSigned + date
                        let sumVatAmountsSigned = 0;
                        let sumNetAmountsSigned = 0;

                        if (period === "previousPeriod") {
                            const vatAmountsSignedFiltered = adjustmentAccountingLines[
                                period
                            ].filter((al) =>
                                al.accountableAccount?.connect?.uniqueName?.name?.startsWith("445"),
                            );

                            if (
                                vatAmountsSignedFiltered.length &&
                                vatAmountsSignedFiltered.length > 1
                            ) {
                                sumVatAmountsSigned = mathFix(
                                    vatAmountsSignedFiltered.reduce(
                                        (a, b) => a + (b["amountSigned"] || 0),
                                        0,
                                    ),
                                    2,
                                );
                            } else if (vatAmountsSignedFiltered.length) {
                                sumVatAmountsSigned = vatAmountsSignedFiltered[0].amountSigned || 0;
                            }
                        } else if (period !== "nextPeriod") {
                            console.error(
                                "🚀 - file: DocumentAdjustments.vue - line 1047 - createAdjustments - ERROR : not existing period",
                                period,
                            );
                            debugger; // git-ignore
                        }

                        const netAmountsFiltered = adjustmentAccountingLines[period].filter(
                            (al) =>
                                al.accountableAccount?.connect?.uniqueName?.name?.startsWith("6") ||
                                al.accountableAccount?.connect?.uniqueName?.name.startsWith("7"),
                        );

                        if (netAmountsFiltered && netAmountsFiltered.length) {
                            sumNetAmountsSigned =
                                netAmountsFiltered.reduce(
                                    (a, b) => a + (b["amountSigned"] || 0),
                                    0,
                                ) || 0;
                            // ** sign opposite of net + vat
                            const grossAmountSigned = -mathFix(
                                sumNetAmountsSigned + sumVatAmountsSigned,
                                2,
                            );
                            const grossAmount = Math.abs(grossAmountSigned);

                            const aa =
                                this.types[this.adjustments.type][period].creditNote[
                                    this.document.creditNote
                                ].thirdPartyAccountableAccount;

                            // ** getEmptyDocument transform dates into getDBFormattedDate
                            adjustmentAccountingLines[period].push({
                                company: { connect: { id: this.companyId } },
                                // type: "MANAGACCOU", // ** default value
                                date:
                                    period === "previousPeriod"
                                        ? this.adjustments.previousDate
                                        : this.adjustments.nextDate, // ** YYYY-MM-DD
                                wording: adjustmentAccountingLines[period][0].wording || "",
                                amountSigned: grossAmountSigned,
                                amount: grossAmount,
                                // eslint-disable-next-line no-await-in-loop
                                accountableAccount: await getConnectAccountableAccount(
                                    this.$store,
                                    this.$apollo,
                                    aa,
                                ),
                            });

                            // ** getEmptyDocument transform dates into getDBFormattedDate
                            const adjDocument: any = getEmptyDocument(
                                this.companyId,
                                adjustmentAccountingLines[period][0].wording,
                                "MISCELLANEOUS_OPERATION",
                                adjustmentAccountingLines[period][0].date,
                                this.currentUser.id,
                                this.controlThirdPartyCompany.id || undefined,
                                adjustmentAccountingLines[period],
                                true,
                            );

                            this.documents.push(adjDocument);
                        }
                    }
                }
            }
        }

        // **** generate data
        const data = [];

        for (const line of this.adjustments.lines) {
            data.push({
                originalDocumentId: this.document.id,
                type: this.adjustments.type,
                status: line.adjustment.status,
                thirdPartyCompany: this.tpcIdNameObject || undefined,
                date: line.date,
                accountableAccount: line.accountableAccount,
                netAmountSigned: line.netAmountSigned,
                vatRate: line.vatRate || 0,
                vatAmountSigned: line.vatAmountSigned,
                adjustment: line.adjustment,
                periods: line.periods,
            });
        }

        let auditCheckResultVariables: any = {};

        // // create an object.type for document + bankTransaction create + update
        // // ternaire
        // // documentCreateConnection: al.object.objectType === "document" ? {connect:{ id:al.object.id}} : undefined,
        // // documentUpdateConnection: al.object.objectType === "document" ? {connect:{ id:al.object.id}} : undefined,
        // // bankTransactionCreateConnection: al.object.objectType === "bankTransaction" ? {connect:{ id:al.object.id}} : undefined,
        // // bankTransactionUpdateConnection: al.object.objectType === "bankTransaction" ? {connect:{ id:al.object.id}} : undefined,

        if (this.acKey && this.companyId && this.document.id) {
            auditCheckResultVariables = {
                id:
                    this.auditCheckResult && this.auditCheckResult.id
                        ? this.auditCheckResult.id
                        : "",
                key: this.acKey + "_" + this.document.id,
                companyId: this.companyId,
                status: "UNKNOWN",
                thirdPartyCompanyCreate: this.tpcIdUpsertObject,
                thirdPartyCompanyUpdate: this.tpcIdUpsertObject,
                accountingPeriodCreate: this.documentAccountingPeriod?.id
                    ? { connect: { id: this.documentAccountingPeriod.id } }
                    : undefined,
                accountingPeriodUpdate: this.documentAccountingPeriod?.id
                    ? { connect: { id: this.documentAccountingPeriod.id } }
                    : undefined,
                documentCreateConnection: { connect: { id: this.document.id } },
                documentUpdateConnection: { connect: { id: this.document.id } },
                documents: this.documents || undefined,
                deleteDocuments: this.previousDocumentsIds || undefined,
                data: JSON.parse(JSON.stringify(data)) || [],
                auditCheckKey: this.acKey,
            };
        }

        if (auditCheckResultVariables) {
            await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT,
                variables: auditCheckResultVariables,
            });
        }

        this.removedLinesMessage = "";

        location.reload();
        this.backPath();

        // ++++++++++++++ RESET +++++++++++++++++++
        // ** no apollo.queries
        // ** all comes from Prop document + mounted + calculate
        // if (this.$apollo.queries && this.$apollo.queries.auditItems) {
        //     this.$apollo.queries.auditItems.refetch();
        // } else {
        //     debugger
        // }

        // this.initialiseCompany()
    }

    initialize() {
        this.adjustments = this.defaultAdjustments;
    }

    getDatePickerError(startDate, endDate) {
        if (this.disabledTextFields) {
            return false;
        }
        const start = moment(startDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");
        if (end < start) {
            return true;
        }
        if (this.minDateYYYYMMDD00 && start < this.minDateYYYYMMDD00) {
            return true;
        }
        return false;
    }

    async deleteAuditCheckResult(acrId) {
        const deletedACR = await this.$apollo.mutate({
            mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
            variables: { id: acrId },
        });

        if (deletedACR) {
            if (this.$apollo.queries?.auditCheckResult) {
                this.$apollo.queries.auditCheckResult.refetch();
            } else {
                // eslint-disable-next-line
                debugger; // git-ignore
            }
            location.reload();
            this.backPath();
        }
    }

    getDisplayName(aaName) {
        if (aaName) {
            return aaName;
        }
        return "XXXXXX";
    }
}

export default toNative(DocumentAdjustments);
</script>

<style></style>
